module.exports = __webpack_public_path__ + "img/location.fb015cbe.svg";